import { render, staticRenderFns } from "./ContactListPlaceholder.vue?vue&type=template&id=45cc3612&scoped=true&"
import script from "./ContactListPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ContactListPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ContactListPlaceholder.vue?vue&type=style&index=0&id=45cc3612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cc3612",
  null
  
)

export default component.exports